module.exports = "/build/web/svg/social/small/twitter-blue.d96d87cef3092ee5cfa01da533c4eb57.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/twitter-blue.svg
// module id = 110
// module chunks = 24